module.exports = __webpack_public_path__ + "/bundle/asset/flowchart-7d9629fcf5874bf20ae73c75808d2bcc.png";